import * as actionTypes from '../action-types';
import { WatcherExistsActions } from '../actions';
import { WatcherExistsType } from '../watchersState.types';

export const defaultState: WatcherExistsType = { watcherKey: '', types: [] };

export function watcherExistsReducer(
  state: WatcherExistsType = defaultState,
  action: WatcherExistsActions,
) {
  switch (action.type) {
    case actionTypes.SET_WATCHER_EXISTS: {
      const { watcherKey, types } = action.payload;
      return { watcherKey, types };
    }
    case actionTypes.UNSET_WATCHER_EXISTS: {
      return { watcherKey: '', types: [] };
    }
    case actionTypes.ADD_QUERIES_TO_WATCHER_EXISTS: {
      const { watcherKey, types } = action.payload;
      return { watcherKey, types: state.types.concat(types) };
    }
    case actionTypes.DELETE_QUERY_FROM_WATCHER_EXISTS: {
      const { watcherKey, type } = action.payload;
      return {
        watcherKey,
        types: state.types.filter(existingType => existingType !== type),
      };
    }
    default: {
      return state;
    }
  }
}
